export enum AboutUs {
  mainTitle = 'aboutUs.mainTitle',
  paragraphFirst = 'aboutUs.paragraphFirst',
  title = 'aboutUs.title',
  paragraphSecond = 'aboutUs.paragraphSecond',
  label = 'aboutUs.label',
}
